<template>
  <div>

    <!-- View definitions modal template -->
    <b-modal ref="view-risk-list"
             hide-footer
             @hide="hideTPModal"
             size="lg"
    >

    <div class="d-block text-center">
      <h4 qid="view-risk-list-title">
        {{ $t('risk_scenarios.dashboard.modal.title') }}
      </h4>
    </div>

    <div class="mt-3 mb-3">
      <span class=" m-2" v-if="risk == 'Very high risk'">
        <font-awesome-icon
            icon="exclamation-triangle"
            :class="'risk-16'"
        />
        {{ $t('risk.very_high_risk') }}
      </span>
      <span class="m-2" v-if="risk == 'High risk'">
        <font-awesome-icon
            icon="exclamation-triangle"
            :class="'risk-9'"
        />
        {{ $t('risk.high_risk') }}
      </span>
      <span class="m-2" v-if="risk == 'Medium risk'">
        <font-awesome-icon
            icon="exclamation-triangle"
            :class="'risk-3'"
        />
        {{ $t('risk.medium_risk') }}
      </span>
      <span class="m-2" v-if="risk == 'Low risk'">
        <font-awesome-icon
            icon="exclamation-triangle"
            :class="'risk-1'"
        />
        {{ $t('risk.low_risk') }}
      </span>
    </div>

    <div class="mt-3 mb-3 modal-tabs-scrollable">
      <table class="table table-responsive-md table-sm">
        <thead>
        <tr>
          <th scope="col">
            {{ $t('activities.risk_scenario.current_risk.table.name') }}
          </th>
          <th scope="col" v-if="getClient.risk_type == 'cia_risk'">
            {{ $t('risk_scenarios.create.risk_type_label') }}
          </th>
          <th scope="col">
            {{ $t('generic_controls.risk_scenarios.create.risk_label') }}
          </th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in risks"
              class="text-bold"
          >
            <td v-if="item">
              <span v-if="filters.scope.value == 'activity'">
                <router-link :to="{ name: 'activities.view', params: { slug: item.activity.slug }}">
                  {{ item.activity.name }}
                </router-link>
              </span>
              <span v-if="filters.scope.value == 'process'">
                <router-link :to="{ name: 'processes.view', params: { slug: item.process.slug }}">
                  {{ item.process.name }}
                </router-link>
              </span>
              <span v-if="filters.scope.value == 'system'">
                <router-link :to="{ name: 'systems.view', params: { slug: item.system.slug }}">
                  {{ item.system.name }}
                </router-link>
              </span>
              <span v-if="filters.scope.value == 'third_party'">
                <router-link :to="{ name: 'contracts.view', params: { slug: item.third_party.slug }}">
                  {{ item.third_party.name }}
                </router-link>
              </span>
            </td>
            <td v-if="getClient.risk_type == 'cia_risk'">
              <div v-if="getConfidentialityLabel(item).length">
                {{ getConfidentialityLabel(item) }}
              </div>
              <div v-if="getIntegrityLabel(item).length">
                {{ getIntegrityLabel(item) }}
              </div>
              <div v-if="getAvailabilityLabel(item).length">
                {{ getAvailabilityLabel(item) }}
              </div>
            </td>
            <td v-if="item">
              <router-link
                  :to="{ name: 'risk_scenarios.view', params: { slug: item.risk_scenario.slug }}"
                  qid="s-view-page-link"
              >
                {{ item.risk_scenario.name }}
              </router-link>
            </td>
          </tr>
          <tr v-if="risks && !risks.length" qid="no-results-row" class="text-center">
            <td colspan="10">
              <h5 class="mt-3">
                {{ $t('system.no_results') }}
              </h5>
            </td>
          </tr>
          <tr class="text-center" @click="loadContent()" v-if="showMore && !loading">
            <td colspan="10">
              <a>{{ $t('system.show_more') }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-button class="float-right"
              variant="success"
              @click="hideTPModal"
              qid="create-p-cancel-button"
    >
      {{ $t('processes.policies.view.close') }}
    </b-button>
    <br>

  </b-modal>

</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'ViewRiskListModal',
    data: function() {
      return {
        error: '',
        loadingItems: false,
        risks: [],
        loading: true,
        page: 1,
        showMore: true,
      }
    },
    props: {
      showModal: {
        type: Boolean
      },
      active: {
        type: Boolean
      },
      impact: {
        type: String
      },
      probability: {
        type: String
      },
      risk: {
        type: String
      },
      filters: {
        type: Object
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showTPModal()
        }
      }
    },
    methods: {
      showTPModal() {
        this.page = 1;
        this.risks = []
        this.showMore = true
        this.$refs['view-risk-list'].show()
        this.loadContent()
      },
      hideTPModal() {
        this.error = ''
        this.risks = []
        this.$emit('closeViewModal');
        this.$refs['view-risk-list'].hide()
      },
      getConfidentialityLabel(object) {
        let label = ''

        if (this.filters && this.filters.area && this.filters.area.value && this.filters.type && this.filters.type.value) {

          if (!this.filters.cia_type || (this.filters.cia_type && this.filters.cia_type.value == 'confidentiality')) {

            if (this.filters.area.value == 'business') {

              if (this.filters.type.value == 'current') {
                if (object.residual_business_risk) {
                  if (this.impact == object.residual_business_risk.confidentiality_impact && this.probability == object.residual_business_risk.confidentiality_probability) {
                    label = 'Confidentiality'
                  }
                }
              }
              if (this.filters.type.value == 'inherent') {
                if (this.impact == object.business_confidentiality_risk_impact && this.probability == object.business_confidentiality_risk_probability) {
                  label = 'Confidentiality'
                }
              }

            }
            if (this.filters.area.value == 'privacy') {

              if (this.filters.type.value == 'current') {
                if (object.residual_business_risk) {
                  if (this.impact == object.residual_privacy_risk.confidentiality_impact && this.probability == object.residual_privacy_risk.confidentiality_probability) {
                    label = 'Confidentiality'
                  }
                }
              }
              if (this.filters.type.value == 'inherent') {
                if (this.impact == object.privacy_confidentiality_risk_impact && this.probability == object.privacy_confidentiality_risk_probability) {
                  label = 'Confidentiality'
                }
              }

            }
          }
        }

        return label
      },
      getIntegrityLabel(object) {
        let label = ''

        if (this.filters && this.filters.area && this.filters.area.value && this.filters.type && this.filters.type.value) {

          if (!this.filters.cia_type || (this.filters.cia_type && this.filters.cia_type.value == 'integrity')) {

            if (this.filters.area.value == 'business') {

              if (this.filters.type.value == 'current') {
                if (object.residual_business_risk) {
                  if (this.impact == object.residual_business_risk.integrity_impact && this.probability == object.residual_business_risk.integrity_probability) {
                    label = 'Integrity'
                  }
                }
              }
              if (this.filters.type.value == 'inherent') {
                if (this.impact == object.business_integrity_risk_impact && this.probability == object.business_integrity_risk_probability) {
                  label = 'Integrity'
                }
              }

            }
            if (this.filters.area.value == 'privacy') {

              if (this.filters.type.value == 'current') {
                if (object.residual_business_risk) {
                  if (this.impact == object.residual_privacy_risk.integrity_impact && this.probability == object.residual_privacy_risk.integrity_probability) {
                    label = 'Integrity'
                  }
                }
              }
              if (this.filters.type.value == 'inherent') {
                if (this.impact == object.privacy_integrity_risk_impact && this.probability == object.privacy_integrity_risk_probability) {
                  label = 'Integrity'
                }
              }

            }
          }
        }

        return label
      },
      getAvailabilityLabel(object) {
        let label = ''

        if (this.filters && this.filters.area && this.filters.area.value && this.filters.type && this.filters.type.value) {

          if (!this.filters.cia_type || (this.filters.cia_type && this.filters.cia_type.value == 'availability')) {

            if (this.filters.area.value == 'business') {

              if (this.filters.type.value == 'current') {
                if (object.residual_business_risk) {
                  if (this.impact == object.residual_business_risk.availability_impact && this.probability == object.residual_business_risk.availability_probability) {
                    label = 'Availability'
                  }
                }
              }
              if (this.filters.type.value == 'inherent') {
                if (this.impact == object.business_availability_risk_impact && this.probability == object.business_availability_risk_probability) {
                  label = 'Availability'
                }
              }

            }
            if (this.filters.area.value == 'privacy') {

              if (this.filters.type.value == 'current') {
                if (object.residual_business_risk) {
                  if (this.impact == object.residual_privacy_risk.availability_impact && this.probability == object.residual_privacy_risk.availability_probability) {
                    label = 'Availability'
                  }
                }
              }
              if (this.filters.type.value == 'inherent') {
                if (this.impact == object.privacy_availability_risk_impact && this.probability == object.privacy_availability_risk_probability) {
                  label = 'Availability'
                }
              }

            }
          }
        }

        return label
      },
      loadContent() {
        let self = this;

        piincHttp.get('risk-scenarios/statistics/data', { params:
          {
            client: this.getClient.slug,
            area: this.filters.area ? this.filters.area.value : undefined,
            type: this.filters.type ? this.filters.type.value : undefined,
            scope: this.filters.scope ? this.filters.scope.value : undefined,
            cia_risk_type: this.filters.cia_type ? this.filters.cia_type.value : undefined,
            impact: this.impact,
            probability: this.probability,
            page: this.page,
            per_page: 10
          }
        }).then(function(response) {
          if (response.data.items && (response.data.items.length < 10 || (response.data.items.length == 10 && response.data.total_count == 10 * self.page))) {
            self.showMore = false;
          }

          self.page += 1;
          self.loading = false;
          self.risks.push(...response.data.items)
        }, function(error) {
          self.error = error.data
          self.loading = false;
        })

      },
    },
    components: {

    },
    created () {

    }
  }
</script>
